import { Container, Row, Col, Card } from 'react-bootstrap';
import { Star } from 'lucide-react';

const SuccessStories = () => {
  const testimonials = [
    {
      name: "Sarah M.",
      category: "Photography Equipment Lender",
      earnings: "₹1,00,000/month",
      rating: 5,
      text: "I've been lending my camera gear for 8 months and it's been amazing. The extra income helps me upgrade my equipment regularly."
    },
    {
      name: "Mike R.",
      category: "Tool & Equipment Lender", 
      earnings: "₹65,000/month",
      rating: 5,
      text: "My power tools were just sitting in the garage. Now they're earning me enough to cover my mortgage payment each month!"
    },
    {
      name: "Jennifer L.",
      category: "Outdoor Gear Lender",
      earnings: "₹50,000/month", 
      rating: 5,
      text: "Shaxify made it so easy to rent out my camping gear. The insurance coverage gives me complete peace of mind."
    }
  ];

  return (
    <section id="stories" className="section-padding gradient-section">
      <Container>
        <div className="text-center mb-5">
          <h2 className="display-4 fw-bold mb-4" style={{color: 'var(--text-dark)'}}>
            Success Stories
          </h2>
          <p  className="text-gray fs-5"  style={{color: 'var(--text-muted)'}}>
            Real stories from real earning owners
          </p>
        </div>

        <Row className="g-4">
          {testimonials.map((testimonial, index) => (
            <Col md={4} key={index}>
              <Card className="h-100 border-0 shadow-sm card-hover">
                <Card.Body className="p-4">
                  {/* Rating Stars */}
                  <div className="d-flex align-items-center mb-3">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} size={20} style={{color: '#FACC15', fill: '#FACC15'}} />
                    ))}
                  </div>

                  {/* Testimonial Text */}
                  <Card.Text className="mb-4" style={{color: 'var(--text-muted)', lineHeight: '1.6'}}>
                    "{testimonial.text}"
                  </Card.Text>

                  {/* User Info */}
                  <div className="border-top pt-3" style={{borderColor: 'var(--border-light) !important'}}>
                    <div className="fw-bold mb-1" style={{color: 'var(--text-dark)'}}>
                      {testimonial.name}
                    </div>
                    <div className="small mb-2" style={{color: 'var(--text-muted)'}}>
                      {testimonial.category}
                    </div>
                    <div className="fw-bold text-green" >
                      {testimonial.earnings}
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default SuccessStories;

